"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=()=>{try{return Intl.supportedValuesOf("timeZone")}catch{return console.error("Cannot get timeZones list"),[]}};exports.getTimeZonesList=e;
